let days;
let hours;
let minutes;
let seconds;
let target;

const update = () => {
    const difference = parseInt(target - new Date().getTime(), 10);
    let s = difference / 1000;
    let m = s / 60;
    let h = m / 60;
    let d = h / 24;

    d = String(parseInt(d, 10)).padStart(2, '0');
    h = String(parseInt(h % 24, 10)).padStart(2, '0');
    m = String(parseInt(m % 60, 10)).padStart(2, '0');
    s = String(parseInt(s % 60, 10)).padStart(2, '0');

    days.innerHTML = `<span>${d.slice(0, 1)}</span><span>${d.slice(1, 2)}</span>${d > 99 ? `<span>${d.slice(2, 3)}</span>` : ''}`;
    hours.innerHTML = `<span>${h.slice(0, 1)}</span><span>${h.slice(1, 2)}</span>`;
    minutes.innerHTML = `<span>${m.slice(0, 1)}</span><span>${m.slice(1, 2)}</span>`;
    seconds.innerHTML = `<span>${s.slice(0, 1)}</span><span>${s.slice(1, 2)}</span>`;
};

const init = () => {
    const container = document.querySelector('.js-countdown');
    if (!container) return;

    target = new Date(container.dataset.targetTime).getTime();

    days = container.querySelector('.js-countdown-days');
    hours = container.querySelector('.js-countdown-hours');
    minutes = container.querySelector('.js-countdown-minutes');
    seconds = container.querySelector('.js-countdown-seconds');

    setInterval(update, 1000);
};

export default init;
